import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-movements-edit',
		path: '/admin/m/:slug',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin_movements_edit" */ './index'), {
			exportName: 'AdminMovementEdit',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: 'staff',
		},
		frame: true,
		ssr: {
			// switch this to true to enable SSR
			enabled: true,
			seo: false,
		},
	},
];
